<template>
  <div class="home">
    <h3 class="title">
      แตะที่โลโก้เพื่อเลือกการคำนวณที่ต้องการ
    </h3>
    <b>KMP application family</b>
    <br />
    <ul>
      <li>
        <a
          href="https://www.facebook.com/KeepMovingPharmacist/posts/4275517952522835"
          >KMP - High alert drug</a
        >
      </li>

      <li>
        <a
          href="https://www.facebook.com/KeepMovingPharmacist/posts/4039713616103271"
          >KMP - TB Drug Calculator คำนวณขนาดยาต้านวัณโรค</a
        >
      </li>

      <li>
        <a
          href="https://www.facebook.com/KeepMovingPharmacist/posts/4106031086138190"
          >KMP - Vancomycin calculator</a
        >
      </li>
      <li>
        <a
          href="https://www.facebook.com/KeepMovingPharmacist/posts/4076148259126473"
          >KMPCalc</a
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      d1: 5,
      d2: 10,
      vt: 1000,
      nacl: 0.9,
    };
  },
};
</script>

<style scope>

</style>
